import { styled, TextField } from "@mui/material";

const SearchBar = (props) => {
  return <CustomTextField {...props} />;
};

const CustomTextField = styled(TextField)(() => ({
  margin: "0px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
  },
}));

export default SearchBar;
